import { FoodOrderingState} from '@/types/state'
import * as actionTypes from '@/store/action-types'
import * as mutationTypes from '@/store/mutation-types'
import MenuOffer from '@/model/dailymenu/MenuOffer'
import * as getterTypes from '@/store/getter-types'
import DailyMenuOffer from '@/model/dailymenu/DailyMenuOffer'
import { DailyMenuChangeSet } from '@/types'

import axios from '@/plugins/axios'
import { AVAILABLE_DAILY_MENU } from '@/store/action-types'
import Moment from 'moment'
import { USER_LOGGED_IN } from '@/store/getter-types'
import store from '@/store'
import DailyMenuOption from "@/model/dailymenu/DailyMenuOption";
import {FoodMenuOfferPayload} from "@/types/payload";
import {EditSlotPayload} from "@/types/payload";
import FoodItem from "@/model/food-database/FoodItem";
import {Buffer} from "buffer"
const state: FoodOrderingState = {
  userDailyMenu: MenuOffer.createEmpty(),
  templateDailyMenu: MenuOffer.createEmpty(),
  currentDailyMenuTopGroupOffer: undefined,
  dailyMenuTopGroupChangeSet: undefined,
  currentUserReservationRangeData: undefined,
  reservationDataSaved: undefined,
  currentDailyMenuOffer: undefined,
  loadingData: false,
  searchFoodItems: [],
  currentDailyMenuTemplate: undefined,
  dailyMenuChangeSet: undefined,
  userSettings4Ordering: undefined
}

const getters = {

  [getterTypes.TEMPLATE_MENU_OFFER] (state: FoodOrderingState): MenuOffer {
    return state.templateDailyMenu
  },

  [getterTypes.DAILY_MENU_OFFER_TEMPLATE] (state: FoodOrderingState): DailyMenuOffer | undefined {
    return state.currentDailyMenuTemplate
  },

  [getterTypes.DAILY_MENU_CHANGE_SET] (state: FoodOrderingState): DailyMenuChangeSet | undefined {
    return state.dailyMenuChangeSet
  },

  [getterTypes.LOADING_DAILYMENU] (state: FoodOrderingState): boolean {
    return state.loadingData
  },
  [getterTypes.SEARCHED_FOOD] (state: FoodOrderingState): FoodItem[] | undefined {
    return state.searchFoodItems
  },
}

const mutations = {

  [mutationTypes.SET_CURRENT_DAILYMENU] (state: FoodOrderingState, payload: MenuOffer): void {
    state.templateDailyMenu = payload
  },

  [mutationTypes.SET_SELECTED_DAILYMENU_TEMPLATE] (state: FoodOrderingState, payload: DailyMenuOffer): void {
    state.currentDailyMenuTemplate = payload
  },

  [mutationTypes.SET_LOADING_DAILYMENU] (state: FoodOrderingState, payload: boolean): void {
    state.loadingData = payload
  },
  [mutationTypes.SET_SEARCHED_FOOD] (state: FoodOrderingState, payload: FoodItem[]): void {
    state.searchFoodItems = payload
  }
}

const actions = {
  async [actionTypes.AVAILABLE_DAILY_MENU] ({ commit }: { commit: Function }, payload: any): Promise<void> {

    const user = store.getters[USER_LOGGED_IN]

    commit(mutationTypes.SET_LOADING_DAILYMENU, true)

    let headers = {
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }

    let res = await axios.get('/api/food-ordering/' + user.tenant.code + '/menu-offer?s=' + payload.from + '&e=' + payload.to,{ headers:headers})

    const data = MenuOffer.createFromResponse(res.data)

    commit(mutationTypes.SET_CURRENT_DAILYMENU, data)
    commit(mutationTypes.SET_LOADING_DAILYMENU, false)

  },

  async [actionTypes.FETCH_DAILY_MENU] ({ commit }: { commit: Function }, payload: any): Promise<MenuOffer> {

    const user = store.getters[USER_LOGGED_IN]

    commit(mutationTypes.SET_LOADING_DAILYMENU, true)

    let headers = {
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }

    let res = await axios.get('/api/food-ordering/' + user.tenant.code + '/menu-offer?s=' + payload.from + '&e=' + payload.to,{ headers:headers})

    return MenuOffer.createFromResponse(res.data)
  },

  async [actionTypes.SEARCH_FOOD_ITEM] ({ commit }: { commit: Function }, payload: any): Promise<any> {

    commit(mutationTypes.SET_LOADING_DAILYMENU, true)

    let headers = {
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }

    let res = await axios.get('/api/food-database/food-item/slot-suitable?slot-id=' + payload.slot + '&q=' + Buffer.from(payload.searchText).toString('base64'),{ headers:headers})

    //commit(mutationTypes.SET_SEARCHED_FOOD, res.data)
    commit(mutationTypes.SET_LOADING_DAILYMENU, false)

    return res.data
  },

  [actionTypes.SWITCH_DAILYMENU] ({ commit }: { commit: Function }, payload: DailyMenuOffer): void {

    commit(mutationTypes.SET_SELECTED_DAILYMENU_TEMPLATE, payload)

//     const changeSet = createInitialDailyMenuChangeSet(payload)

  },

  async [actionTypes.SAVE_FODD_TO_DAILYMENU] ({ commit, state, dispatch }: { commit: Function, state: FoodOrderingState, dispatch:Function }, payload: FoodMenuOfferPayload):  Promise<void> {

    commit(mutationTypes.SET_LOADING_DAILYMENU, true)

    let headers = {
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }

    if( payload.type == "POST") {
      const response =await axios.post('/api/food-ordering/daily-menu-offer',payload.foodItem,{ headers:headers})
      return response.data
    }

    else if( payload.type == "PUT" ) {
      const response =await axios.put('/api/food-ordering/daily-menu-offer/'+payload.id, payload.foodItem,{ headers:headers})
      return response.data
    }

    // RELOAD CALENDAR LIST AND READ DATA FOR DATE RANGE
    if(state.templateDailyMenu && state.templateDailyMenu.menuList.length > 0)
    {
      const start_date = Moment(state.templateDailyMenu.menuList[0].date).format("Y-MM-DD")
      const end_date = Moment(state.templateDailyMenu.menuList[state.templateDailyMenu.menuList.length-1].date).format("Y-MM-DD")
      dispatch(AVAILABLE_DAILY_MENU,{from:start_date,to:end_date})

    }

    commit(mutationTypes.SET_SEARCHED_FOOD, [])
    commit(mutationTypes.SET_LOADING_DAILYMENU, false)

  },

  async [actionTypes.UPDATE_SLOT] ({}, payload: EditSlotPayload): Promise<DailyMenuOption> {
    let headers = {
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }

    const result = await axios.put(`/api/menu-group-slot/${payload.id}`, {
      referencePrice: payload.referencePrice,
      title: payload.title,
      code: payload.code,
      tags: payload.tags,
      order:payload.order
    },{ headers:headers})

    //return DailyMenuOption.createSingleFromResponse(result.data)
    return result.data
  }
}

const foodOrderingModule = {
  state,
  getters,
  mutations,
  actions
}

export default foodOrderingModule
